import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import type { Playlist, PlaylistId } from 'types/playlist'
import { updatePlaylistBaseObj } from '@disco/state-management/actions/playlist-actions'
import { loadBatch } from '@disco/state-management/actions/PlaylistTrackActions'
import PlaylistSelectionDialog from 'components/modals/playlist-selection-dialog'

const WatermarkPlaylistModal = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const getOptions = async ({
    callback,
    playlists,
  }: {
    callback: (err: Error | null | undefined, result?: any) => void
    playlists: Playlist[]
  }) => {
    try {
      dispatch(loadBatch(playlists))
      const result = {
        options: playlists
          .map(r => {
            const disabled = r.watermark
            if (disabled) return null
            return {
              value: r.playlist_id,
              label: r.name,
            }
          })
          .filter(Boolean),
        complete: false,
      }
      callback(null, result)
    } catch (err) {
      callback(err)
    }
  }

  const onSubmit = (playlistIds: PlaylistId[]) => {
    const playlistId = playlistIds[0]
    if (playlistId === undefined) return
    dispatch(
      updatePlaylistBaseObj(
        playlistId,
        {
          watermark: true,
        },
        {
          success: 'Playlist watermarked!',
          error: 'Sorry! Failed to watermark playlist.',
        },
      ),
    )
    onClose()
  }

  const onClose = () => navigate('/watermarking')

  return (
    <PlaylistSelectionDialog
      onSubmit={onSubmit}
      onClose={onClose}
      title="Watermark a playlist"
      submitButtonCaption="Watermark playlist"
      getOptions={getOptions}
      checkForApiUpdates
    />
  )
}

export default WatermarkPlaylistModal
